import Cart from "./cart";
import ProgramType from "./enums/program-type";
import Item from "./item";
import StagingArea from "./staging-area";
import PickProgress from "./pick-progress";

const item2 = new Item();
item2.sequence = 2;
item2.itemId = "item2";
item2.scannableId = "item2";
item2.containerColor = "green";
item2.label = "label2";
item2.itemType = "BAG";
item2.itemStatus = "STOWED";

const item3 = new Item();
item3.sequence = 3;
item3.itemId = "item3";
item3.scannableId = "item3";
item3.label = "label3";
item3.itemType = "PACKAGE";
item3.itemStatus = "STOWED";

export default class PicklistInfo {

    constructor() {
        this.id = "picklistId";
        this.code = "CA_88";
        this.status = "IN_PROGRESS";
        this.cart = new Cart();
        this.pickProgress = new PickProgress();
        this.stagingArea = new StagingArea();
        this.itemList = [new Item(), item3, item2];
        this.aisles = ["A1", "A2"];
        this.chutes = ["C1", "C2"];
        this.carts = [new Cart(), new Cart()];
        this.routeLength = "50";
        this.programType = ProgramType.AMZL;
        this.executionMode = "INSTRUCTIONS";
    }
}



// WEBPACK FOOTER //
// ./src/models/picklist-info.js